import React from 'react';
import PropTypes from 'prop-types';

// must be defined outside of the component to avoid re-rendering loops
const defaultStyle = {};
const Loader = ({
  children: _children = null,
  loaded: _loaded = false,
  style: _style = defaultStyle,
  failed: _failed = false,
  failedMessage: _failedMessage = 'Unable to load content'
}) => {
  let message = '';
  let className = null;
  let newChildren = _children;
  if (_failed) {
    newChildren = null;
    className = null;
    message = _failedMessage;
  } else if (!_loaded) {
    newChildren = null;
    className = 'loader';
    message = 'Loading...';
  }
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: _style,
    "data-testid": "loader"
  }, /*#__PURE__*/React.createElement("h3", null, message), newChildren);
};
Loader.propTypes = {
  children: PropTypes.node,
  loaded: PropTypes.bool,
  failed: PropTypes.bool,
  failedMessage: PropTypes.string,
  style: PropTypes.shape({})
};
export default Loader;